import { createNumberMask } from 'redux-form-input-masks';

const brCurrencyMask = createNumberMask({
  suffix: '%',
  decimalPlaces: 2,
  locale: 'pt-BR',
});

export default brCurrencyMask;
